import { createWsConnectionSlice } from '@skynet/data-ws-core';
import { assistantActions } from './actions';

const wsAssistantSlice = createWsConnectionSlice('wsAssistant', assistantActions);

export type WsAssistantState = ReturnType<typeof wsAssistantSlice.getInitialState>;

export const wsAssistantActions = wsAssistantSlice.actions;

export default wsAssistantSlice.reducer;
